import { Component, input } from '@angular/core'
import { MetricModel } from '../../../models/metric.model'

@Component({
  selector: 'app-legend-category',
  templateUrl: './legend-category.component.html',
  standalone: false,
})
export class LegendCategoryComponent {
  name = input('')
  metric = input<MetricModel | undefined>(undefined)
}
